import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
  ["gold_24kt", "Oro 24kt"],
  ["gold_22kt", "Oro 22kt"],
  ["gold_21kt", "Oro 21kt"],
  ["gold_18kt", "Oro 18kt"],
  ["gold_14kt", "Oro 14kt"],
  ["gold_9kt", "Oro 9kt"],
  ["silver_925", "Argento 925"],
];

export default function AdminQuotazioni() {
  const [q, setQ] = useState(null);
  const [live, setLive] = useState({});
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/quotes").then((r) => { setQ(r.data.manual); setLive(r.data.live || {}); });
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/quotes", {
        gold_24kt: parseFloat(q.gold_24kt),
        gold_22kt: parseFloat(q.gold_22kt),
        gold_21kt: parseFloat(q.gold_21kt),
        gold_18kt: parseFloat(q.gold_18kt),
        gold_14kt: parseFloat(q.gold_14kt),
        gold_9kt: parseFloat(q.gold_9kt),
        silver_925: parseFloat(q.silver_925),
        spread_percent: parseFloat(q.spread_percent || 0),
        note: q.note || "",
      });
      toast.success("Quotazioni aggiornate!");
      load();
    } catch (e) { toast.error("Errore"); }
    finally { setSaving(false); }
  };

  const applyLive = () => {
    if (!live || !live.live_gold_eur_g_24kt) return;
    const factors = { gold_22kt: 0.916, gold_21kt: 0.875, gold_9kt: 0.375 };
    setQ({
      ...q,
      gold_24kt: live.live_gold_eur_g_24kt,
      gold_22kt: +(live.live_gold_eur_g_24kt * factors.gold_22kt).toFixed(2),
      gold_21kt: +(live.live_gold_eur_g_24kt * factors.gold_21kt).toFixed(2),
      gold_18kt: live.live_gold_eur_g_18kt,
      gold_14kt: live.live_gold_eur_g_14kt,
      gold_9kt: +(live.live_gold_eur_g_24kt * factors.gold_9kt).toFixed(2),
      silver_925: live.live_silver_eur_g_925,
    });
    toast.info("Valori live caricati. Premi 'Salva' per confermare.");
  };

  if (!q) return <div className="p-10 text-white/40">Caricamento...</div>;

  return (
    <div data-testid="admin-quotazioni" className="p-10 max-w-4xl">
      <h1 className="font-serif text-4xl text-white mb-2">Quotazioni</h1>
      <p className="text-white/50 text-sm mb-6">Aggiorna le quotazioni di acquisto in €/g (oro 24·22·21·18·14·9 carati e argento 925).</p>

      {live?.live_gold_eur_g_24kt && (
        <button onClick={applyLive} data-testid="apply-live" className="btn-ghost-gold mb-6 !text-[0.7rem]">
          Carica valori live da BullionVault
        </button>
      )}

      <form onSubmit={save} className="luxe-card p-8 space-y-6">
        <div className="grid md:grid-cols-2 gap-5">
          {FIELDS.map(([k, l]) => (
            <div key={k}>
              <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">{l} (€/g)</label>
              <input
                data-testid={`quote-input-${k}`}
                type="number" step="0.01" required
                value={q[k] ?? 0}
                onChange={(e) => setQ({ ...q, [k]: e.target.value })}
                className="w-full bg-transparent border border-white/15 px-4 py-3 text-white focus:border-[var(--gold)] outline-none"
              />
            </div>
          ))}
        </div>
        <div>
          <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">Nota</label>
          <input value={q.note || ""} onChange={(e) => setQ({ ...q, note: e.target.value })} className="w-full bg-transparent border border-white/15 px-4 py-3 text-white focus:border-[var(--gold)] outline-none" />
        </div>
        <button data-testid="quote-save" type="submit" disabled={saving} className="btn-gold">
          {saving ? "Salvataggio..." : "Salva Quotazioni"}
        </button>
        <p className="text-xs text-white/30">Ultimo aggiornamento: {q.updated_at ? new Date(q.updated_at).toLocaleString("it-IT") : "—"}</p>
        {live?.fetched_at && (
          <p className="text-xs text-[var(--gold-soft)]/70">
            Live BullionVault: 24kt € {Number(live.live_gold_eur_g_24kt).toFixed(2)} · 18kt € {Number(live.live_gold_eur_g_18kt).toFixed(2)} · 14kt € {Number(live.live_gold_eur_g_14kt).toFixed(2)} · Arg.925 € {Number(live.live_silver_eur_g_925).toFixed(2)}
          </p>
        )}
      </form>
    </div>
  );
}
